import { Autocomplete, TextField } from '@mui/material';
import _ from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';

import { fetchSitesForListWithFilters } from '@sophocles/api/sites';

function SiteAutocomplete({
  siteGroupId,
  name,
  value,
  size,
  error,
  helperText,
  required,
  fullWidth,
  disabled,
  onChange,
  onBlur,
  filters,
  ignoreIds = [],
  sx = [],
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);

  const saveDataToState = inputData => {
    const newData = inputData
      .filter(row => !ignoreIds.includes(row.id))
      .map(row => {
        const label = `${row.name}. ${row.description}`;
        return {
          label,
          value: _.get(row, 'id', 0),
        };
      });
    setData(inputData);
    setOptions(newData);
  };

  const fetchData = () => {
    setIsLoading(true);
    fetchSitesForListWithFilters(0, 25, siteGroupId, filters || {}, '', ['name'])
      .then(response => {
        if (_.has(response, 'results')) {
          saveDataToState(response.results);
        } else {
          saveDataToState([]);
        }
      })
      .catch(() => saveDataToState([]))
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (siteGroupId) {
      fetchData();
    }
  }, [siteGroupId]);

  const selectedOption =
    options.find((v, i) => {
      return v.value == value;
    }) || null;

  return (
    <Autocomplete
      disablePortal
      value={selectedOption}
      disabled={disabled}
      options={options}
      isOptionEqualToValue={(option, value) => {
        return option.value === value.value;
      }}
      getOptionLabel={option => {
        return option ? option.label : '';
      }}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      onBlur={onBlur}
      onChange={(e, opt) => {
        e.target = { id: `${name}-autocomplete-input`, name, value: opt ? (opt.value ?? '') : '' };
        onChange(e, opt);
      }}
      renderInput={params => {
        return (
          <TextField
            id={`${name}-autocomplete-input`}
            {...params}
            required={required || false}
            fullWidth={fullWidth || false}
            name={name}
            size={size || 'small'}
            label="Site"
            error={error}
            helperText={helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: <Fragment>{params.InputProps.endAdornment}</Fragment>,
            }}
          />
        );
      }}
    />
  );
}

export default SiteAutocomplete;
